var React = require('react');

function ShoppingAt (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Pin_icon","data-name":"Pin icon","transform":"translate(-38.25 -68.302)"},[React.createElement("path",{"id":"Path_12","data-name":"Path 12","d":"M-37.68,425.968a7.762,7.762,0,0,0-7.823-8.084,7.762,7.762,0,0,0-7.822,8.084c0,3.05,2.542,7.092,7.822,11.916C-40.222,433.06-37.68,429.018-37.68,425.968Z","transform":"translate(92.325 -348.832)","fill":"none","stroke":"#244c5a","strokeMiterlimit":"10","strokeWidth":"1.5","key":0}),React.createElement("circle",{"id":"Ellipse_1","data-name":"Ellipse 1","cx":"2.664","cy":"2.664","r":"2.664","transform":"translate(44.159 74.616)","fill":"#244c5a","key":1})]));
}

ShoppingAt.defaultProps = {"width":"17.145","height":"21.766","viewBox":"0 0 17.145 21.766"};

module.exports = ShoppingAt;

ShoppingAt.default = ShoppingAt;
